<template lang="pug">
  footer#r-footer
    .top
      img(src="../assets/images/logo-red.png")
    .middle
      .content
        .section
          h4.title Menu
          ul
            li(v-for="link in links")
              a(:href="link.link") {{ link.title }}
        .section
          h4.title Redes Sociais
          ul
            li(v-for="socialNetwork in socialNetworks")
              a {{ socialNetwork.socialNetwork }}
              span
                a(:href="socialNetwork.href", target="_blank") {{ socialNetwork.link }}
        .section
          h4.title Encontre-nos
          ul
            li(v-for="contact in cantactInfo")
              a {{ contact.title }}
              span {{ contact.description }}
    .bottom Copyright (c) {{ currentYear }} Copyright Revisa Car Service. All Rights Reserved.
</template>

<script>
export default {
  name: 'RFooter',
  data: () => ({
    links: [
      {
        title: 'Home',
        link: '#',
      },
      {
        title: 'Serviços',
        link: '#ourservices',
      },
      {
        title: 'Por que nós?',
        link: '#why-choose-us',
      },
      {
        title: 'Depoimentos',
        link: '#what-they-say-about-us',
      },
    ],
    socialNetworks: [
      {
        socialNetwork: 'Facebook',
        link: 'facebook.com/revisacarslz',
        href: 'http://facebook.com/revisacarslz'
      },
      {
        socialNetwork: 'Instagram',
        link: 'instagram.com/revisacarslz',
        href: 'http://instagram.com/revisacarslz'
      },
      {
        socialNetwork: 'Twitter',
        link: 'twitter.com/revisacarslz',
        href: 'http://twitter.com/revisacarslz'
      },
    ],
    cantactInfo: [
      {
        title: 'Localização',
        description: 'Avenida Daniel de la Touche, 200 - Cohama, São Luís - MA',
      },
      {
        title: 'Telefone',
        description: '(98) 3304-6126',
      },
      {
        title: 'E-mail',
        description: 'contato@revisacar.slz.br',
      },
      {
        title: 'Horário',
        description: 'Seg – Sex :: 8:00 – 18:00',
      }
    ],
    currentYear: 0
  }),
  created() {
    this.getCurrentYear()
  },
  methods: {
    getCurrentYear() {
      let date = new Date()
      let year = date.getFullYear()
      this.currentYear = year
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../assets/css/resources'

#r-footer
  float left
  width 100%

  .top
    float left
    width 100%
    height 120px
    background-color #F4F4F4
    display flex
    justify-content center
    align-items center

  .middle
    float left
    width 100%
    display flex
    justify-content center
    padding 60px 0
    box-sizing border-box
    background-color #222222

    .content
      width 1366px

      .section
        float left
        width calc(100%/3)

        .title
          font-weight 800
          font-size 30px
          color white
          margin 0
          text-align left

        ul
          float left
          width 100%
          padding 0

          li
            text-align left
            margin 15px 0

            a
              display block
              color white
              font-weight 600
              font-size 13px
              text-transform uppercase
              text-decoration none
              letter-spacing 3px

            span
              text-transform none
              letter-spacing 0
              color white
              font-weight 500
              font-size 15px
              opacity .75

              a
                text-transform none
                letter-spacing 0
                color white
                font-weight 500
                font-size 15px
                opacity .75

  .bottom
    float left
    width 100%
    height 80px
    background-color $revisacar-red
    display flex
    justify-content center
    align-items center
    color white
    font-family 'Raleway', sans-serif
    font-weight 600
    font-size 15px

@media (max-width: 1366px)
  #r-footer
    .top
      height 100px
      background-color #F4F4F4

    .middle
      padding 20px

      .content
        width 100%

        .section
          float left
          width 100%

          .title
            font-weight 800
            font-size 25px
            color white
            margin 0
            text-align center

          ul
            margin-top 8px

            li
              margin 10px 0
              text-align center

              a
                font-size 13px

              span
                font-size 15px

                a
                  font-size 15px

    .bottom
      font-size 12px
</style>



// WEBPACK FOOTER //
// src/components/RFooter.vue